// extracted by mini-css-extract-plugin
export var desktop_only = "HeroMedia-module--desktop_only--bc059";
export var dowload_button_wrapper = "HeroMedia-module--dowload_button_wrapper--d9f16";
export var gradient = "HeroMedia-module--gradient--39943";
export var gradient_container = "HeroMedia-module--gradient_container--0aa0c";
export var media = "HeroMedia-module--media--55096";
export var media_wrapper = "HeroMedia-module--media_wrapper--e5851";
export var mobile_only = "HeroMedia-module--mobile_only--86df4";